<mat-card class="principal-card extracted">
  <mat-card-header>
    <mat-card-title>{{isESOE ? "eSOE Principal Information": "PDF Scan Principal Information"}}</mat-card-title>
    <mat-card-subtitle>{{districtName}}, {{ campusName }}</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <div>
        <label>Name: </label>
        <span class="name">{{ principalName }}</span>
    </div>
    <div>
        <label>Email: </label>
        <span class="email">
        <a [href]="'mailto:' + principalEmail">{{ principalEmail }}</a>
        </span>
    </div>
  </mat-card-content>
</mat-card>